import { ArrowRight } from 'lucide-react'
import { lazy, Suspense, type ReactNode } from 'react'
import type { SiteCopy } from '../../content'

const FadeContent = lazy(() => import('../react-bits/FadeContent'))
type ProcessBlockProps = { copy: SiteCopy['process']; motionEnabled?: boolean }

function Step({ title, body, index, last, motionEnabled }: { title: string; body: string; index: number; last: boolean; motionEnabled: boolean }) {
  const content: ReactNode = <><span className="step-number">0{index + 1}</span><h3>{title}</h3><p>{body}</p>{!last && <ArrowRight className="step-arrow" aria-hidden="true" />}</>
  if (!motionEnabled) return <div className="process-step">{content}</div>
  return <Suspense fallback={<div className="process-step">{content}</div>}><FadeContent className="process-step" disabled={false} initialOpacity={1} delay={index * 120}>{content}</FadeContent></Suspense>
}

export function ProcessBlock({ copy, motionEnabled = true }: ProcessBlockProps) {
  return <section id="process" className="process" aria-labelledby="process-title"><div className="container">
    <div className="section-head"><p className="eyebrow">{copy.eyebrow}</p><h2 id="process-title">{copy.title}</h2><p>{copy.lead}</p></div>
    <div className="process-grid">{copy.steps.map(([title, body], index) => <Step key={title} title={title} body={body} index={index} last={index === copy.steps.length - 1} motionEnabled={motionEnabled} />)}</div>
  </div></section>
}
